/**
 * @module videoGuides
 */
module.exports = () => {
    const showButtons = document.querySelectorAll( '.show-all-video-posts' );
    showButtons.forEach( ( elem ) => elem.addEventListener( 'click', ( e ) => {
        e.preventDefault();
        const button = e.target;
        const paged = button.dataset.paged++;
        const data = new FormData();

        data.append( 'action', 'all_posts' );
        data.append( 'category', button.dataset.category );
        data.append( 'taxonomy', button.dataset.taxonomy );
        data.append( 'paged', paged );

        const params = new URLSearchParams( data );

        fetch( button.dataset.ajax, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: params,
        } ).then( ( response ) => response.text() )
            .then( ( posts ) => {
                document.getElementById( 'posts-' + button.dataset.category ).innerHTML += posts;
                if ( button.dataset.paged === button.dataset.maxpaged ) {
                    button.style.display = 'none';
                }
            } );
    } ) );
}; // exports